<template>
  <q-select
    v-model="model[fieldName]"
    :label="label ? label : ('Showing Badge' + (multiple ? 's' : ''))"
    stack-label
    :options="showingBadges.data"
    :multiple="multiple"
    map-options
    option-value="id"
    emit-value
    clearable
    :disable="disable"
    :readonly="readonly"
    :rules="rules"
    :bottom-slots="bottomSlots"
    @clear="model[fieldName] = (multiple ? [] : null)"
    @update:model-value="$emit('update:model-value')"
  >
    <template #selected-item="scope">
      <q-chip
        :removable="!disable && !readonly"
        dense
        :tabindex="scope.tabindex"
        square
        @remove="scope.removeAtIndex(scope.index); $emit('update:model-value')"
      >
        <template v-if="scope.opt.type === 'icon' || scope.opt.type === 'name-and-icon'">
          <q-icon
            v-if="scope.opt.iconName"
            :name="scope.opt.iconName"
            class="q-chip__icon material-icons q-icon notranslate"
            :class="{ 'q-chip__icon--left': scope.opt.type === 'name-and-icon' }"
          />
          <img
            v-else-if="scope.opt.iconImage"
            :src="scope.opt.iconImageUrl"
            :style="{ 'filter': $q.dark.isActive ? 'brightness(0) invert(1)' : undefined, }"
            style="width: auto; height: 8px;"
          >
        </template>
        <div
          v-if="scope.opt.type === 'name' || scope.opt.type === 'name-and-icon'"
          class="ellipsis"
        >
          {{ scope.opt.displayName }}
        </div>
      </q-chip>
    </template>
    <template #option="scope">
      <q-item
        v-bind="scope.itemProps"
        v-on="scope.itemEvents"
      >
        <q-item-section avatar>
          <q-icon
            v-if="scope.opt.iconName"
            :name="scope.opt.iconName"
          />
          <img
            v-else-if="scope.opt.iconImage"
            :src="scope.opt.iconImageUrl"
            style="width: auto; height: 8px;"
            :style="{ 'filter': $q.dark.isActive ? 'brightness(0) invert(1)' : undefined, }"
          >
        </q-item-section>
        <q-item-section>
          <q-item-label>
            {{ scope.opt.displayName }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script>

export default {
  name: 'ShowingBadgeSelect',
  configuration: ['showingBadges'],
  props: {
    model: {
      type: Object,
      required: true
    },
    fieldName: {
      type: String,
      required: false,
      default: 'showingBadgeIds'
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    },
    rules: {
      type: Array,
      required: false,
      default: () => ([])
    },
    bottomSlots: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    disable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value']
}

</script>
